import styled from "styled-components";
import { Button } from "antd";

export const StyledLinkButton = styled(Button)`
  text-decoration: none;
`;
